export const EXPERIENCE_TYPE = [
  {
    key: "0 To 3 Years",
    value: "0_to_3_years",
  },
  {
    key: "4 To 7 Years",
    value: "4_to_7_years",
  },

  {
    key: "8 To 10 Years",
    value: "8_to_10_years",
  },
  {
    key: "11 To 13 Years",
    value: "11_to_13_years",
  },
  {
    key: "14 To 17 Years",
    value: "14_to_17_years",
  },
  {
    key: "18 To 20 Years",
    value: "18_to_20_years",
  },
  {
    key: "Above 20 Years",
    value: "above_20_years",
  },
];

export const EMPLOYMENT_TYPE = [
  {
    key: "Full Time",
    value: "full_time",
  },
  {
    key: "Part Time",
    value: "part_time",
  },
  {
    key: "Contract",
    value: "contract",
  },

  {
    key: "Contract to Hire",
    value: "contract_to_hire",
  },
];

export const INTERVIEW_STAGE_TYPE = [
  {
    key: "Applied",
    value: "applied",
  },
  {
    key: "Assessment",
    value: "assessment",
  },
  {
    key: "Interview",
    value: "interview",
  },

  {
    key: "Offer",
    value: "offer",
  },
  {
    key: "Hired",
    value: "hired",
  },
  {
    key: "Rejected",
    value: "rejected",
  },
];
